<template>
	<app-modal v-if="show" @close="closeModal" title="" @click.stop="">
		<template v-slot:header>
			<span class="mr-2">
				Update Topping
			</span>
		</template>
		<div class="p-4" style="width: 750px;">
			<div class="flex">
				<div class="flex flex-1 flex-col">
					<marketing-input label-class="w-24" label="Topping Name" v-model="formData.displayedText" />
					<marketing-input
						label-class="w-24"
						label="Description"
						class="flex flex-1"
						v-model="formData.description"
					/>
					<div class="flex items-center gap-4">
						<app-checkbox label="Required" v-model="formData.required" />
						<app-checkbox label="Is Active" v-model="formData.status" />
					</div>
				</div>
				<div class="flex">
					<add-icon-component
						:image="formData.image ? formData.image.stringBase64 : $filters.setImage(formData.imageUrl)"
						:aspect-ratio="2 / 1"
						@on-select="onImageChanged($event)"
						@on-crop="onImageChanged($event)"
					/>
				</div>
			</div>
			<div class="flex justify-end mt-2">
				<app-button class="btn btn-success w-32" @click="updateTopping" :loading="loading" :disabled="!canEdit"
					>Save</app-button
				>
			</div>
		</div>
	</app-modal>
</template>

<script>
	import BusinessService from '../../../services/sales/BusinessService';
	import MarketingInput from '../../../components/marketing/forms/formComponents/MarketingInput';
	import AddIconComponent from '../../../components/marketing/forms/formComponents/AddIconComponent';
	import AppModal from '../../app/AppModal';
	import AppCheckbox from '@/components/app/AppCheckbox';

	export default {
		name: 'UpdateToppingModal',
		components: { AppCheckbox, AppModal, AddIconComponent, MarketingInput },
		props: {
			topping: {
				type: Object,
				required: true,
			},
			businessName: {
				type: String,
				required: true,
			},
			show: {
				required: true,
				type: Boolean,
			},
			canEdit: {
				type: Boolean,
				default: true,
			},
		},
		data: () => ({
			loading: false,
			formData: {
				image: {},
			},
		}),
		computed: {
			businessId() {
				return this.$route.params.id;
			},
		},
		methods: {
			updateTopping() {
				this.loading = true;
				BusinessService.updateTopping(this.businessId, this.formData)
					.then((topping) => {
						this.$emit('updated', topping);
					})
					.catch((err) => {
						this.$notificationService.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			onImageChanged(stringBase64) {
				this.formData.image = { stringBase64 };
			},
			closeModal(data) {
				this.$emit('close', data);
			},
		},
		mounted() {
			this.formData = { ...this.topping };
		},
	};
</script>
